import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_arrow_up.svg';
import Icon, { IconProps } from './icon';

const IconArrowUp = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconArrowUp;
